import React, { useEffect, useRef } from "react";
import { Card } from "../../tremor/Card";
import { Title, Text } from "../../tremor/Text";
import { useDashboard } from "./useDashboard";
import { useBackend } from "../Wrapper";
import { useTheme } from "./useTheme";
import { DashboardHeader } from "../../components/DashboardHeader";
import { DashboardGrid } from "../../components/DashboardGrid";
import { Copilot } from "../Copilot";
import { CreateToolbar } from "../../components/CreateToolbar";
import { LogType } from "@onvo-ai/js";
import { Toaster } from "sonner";
import { Root } from "@radix-ui/react-tabs";
import { AutomationsModal } from "../../components/AutomationsModal";
export const DashboardWrapper = ({ id: dashboardId, children }) => {
    const { backend } = useBackend();
    const { setId, refreshWidgets } = useDashboard();
    const theme = useTheme();
    useEffect(() => {
        if (dashboardId && backend) {
            setId(dashboardId, backend);
            refreshWidgets(backend);
        }
    }, [dashboardId, backend]);
    return children;
};
export const Dashboard = ({ id: dashboardId, className, variant = "default" }) => {
    var _a;
    const { backend, setContainerRef } = useBackend();
    const theme = useTheme();
    const { dashboard, unauthorized, queue, tab } = useDashboard();
    const localRef = useRef(null);
    const style = ((_a = dashboard === null || dashboard === void 0 ? void 0 : dashboard.settings) === null || _a === void 0 ? void 0 : _a.custom_css) || "";
    useEffect(() => {
        if (dashboardId && backend) {
            backend.logs.create({
                type: LogType.ViewDashboard,
                dashboard: dashboardId,
            });
        }
        return () => {
            queue.flush();
        };
    }, [dashboardId, backend]);
    useEffect(() => {
        if (localRef === null || localRef === void 0 ? void 0 : localRef.current) {
            setContainerRef(localRef);
        }
    }, [localRef]);
    let initialTab = 0;
    if ((dashboard === null || dashboard === void 0 ? void 0 : dashboard.tabs) && (dashboard === null || dashboard === void 0 ? void 0 : dashboard.tabs.length) > 0) {
        initialTab = Math.min(...(dashboard === null || dashboard === void 0 ? void 0 : dashboard.tabs.map(a => a.id))) || 0;
    }
    return (React.createElement(DashboardWrapper, { id: dashboardId },
        React.createElement("div", { ref: localRef, key: theme === "dark" ? "dark" : "light", className: `onvo-root-style onvo-dashboard-context  onvo-bg-opacity-100 onvo-relative onvo-scrollbar-thumb-rounded-full onvo-scrollbar-track-transparent onvo-translate-x-0 onvo-h-full onvo-background-color onvo-flex onvo-flex-col ${theme === "dark"
                ? "onvo-dark onvo-scrollbar-thumb-slate-500"
                : "onvo-scrollbar-thumb-slate-400"} ${className}` },
            React.createElement("style", null, style),
            React.createElement(Toaster, { position: "bottom-right", richColors: true }),
            unauthorized && (React.createElement("div", { className: "onvo-absolute onvo-top-0 onvo-left-0 onvo-right-0 onvo-bottom-0 onvo-bg-black/50 onvo-z-[1000] onvo-backdrop-blur-md onvo-flex onvo-justify-center onvo-items-center" },
                React.createElement(Card, { className: "onvo-max-w-screen-md" },
                    React.createElement(Title, null, "Dashboard unavailable"),
                    React.createElement(Text, null,
                        "The dashboard you are trying to access is currently unavailable. If you are the administrator, click",
                        " ",
                        React.createElement("a", { href: "https://dashboard.onvo.ai/settings/billing", className: "onvo-text-blue-500 onvo-underline" }, "here"),
                        " ",
                        "to update your billing.")))),
            React.createElement(Root, { key: initialTab + "", defaultValue: initialTab + "", value: tab + "", className: "onvo-h-full onvo-flex onvo-flex-col onvo-overflow-y-auto onvo-scrollbar-thin" },
                React.createElement(DashboardHeader, { variant: variant }),
                React.createElement(DashboardGrid, { className: "onvo-pb-20" })),
            React.createElement(AutomationsModal, null),
            (!variant || variant === "default") && (React.createElement(Copilot, { coupled: true, dashboardId: dashboardId, variant: "fullscreen", trigger: React.createElement(CreateToolbar, null) })))));
};
//# sourceMappingURL=Dashboard.js.map